module.exports = __webpack_public_path__ + "static/img/03.d1803a5a.jpg";